import {Component, Input, EventEmitter, Output, ElementRef, ViewChild} from '@angular/core';
// tslint:disable-next-line:import-blacklist
import {Subject} from 'rxjs';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';
import * as _ from 'lodash';
import {ToasterService} from 'angular2-toaster';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'title-search-box',
    templateUrl: 'title.search.box.component.html',
    styleUrls: ['title.search.box.component.scss']
})

// tslint:disable-next-line:component-class-suffix
export class TitleSearchBox {
    private disableClick = false;
    private searchValue: any;
    @Input() set initialSearchValue(value: string) {
        this.disableClick = false;
        this.selectedDisplayName = value;
        this.subject.next(value);
    };

    @Input() debounceTime = 750;
    @Input() extended = false;
    @Input() identifier;
    @Output() titleChange = new EventEmitter<string[]>();
    @Output() inputClick = new EventEmitter();
    @Input() searchListHeight = 206;
    @Input() bulkInfoHashSearch = false;
    @Input() category = 'tv';
    @Input() esIndex = 'tv';
    @Input() torrentName = '';
    @Input() initiaParrotId = '';
    @Input() initialDisplayName = '';


    subject = new Subject<string>();
    results = [];
    private finalsResults = [];
    private extendedResults = [];
    private finalsextendedResults = [];
    supplyExtendedResults = [];
    demandExtendedResults = [];
    supplyResults = [];
    demandResults = [];
    loading = false;
    error = false;
    selectedDisplayName = '';
    showSearch = true;
    private searchIndex = 'genome-search';
    private words: any;
    wordCount: any;

    private checkboxes = {
        extended: false
    };

    constructor(private catalogService: CatalogService, private toasterService: ToasterService) {
        this.subject.debounceTime(this.debounceTime)
            .distinctUntilChanged()
            .subscribe(searchValue => {
                this.error = false;
                this.loading = true;
                this.elasticSearchTitle(searchValue);
            });
    }

    createDemandESQuery(searchTerm) {
        const demandQuery = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'multi_match': {
                                'query': searchTerm,
                                'type': 'best_fields',
                                'fields': [
                                    'title',
                                    'display_name',
                                    'data.also_known_as^1.3'
                                ],
                                'minimum_should_match': 1,
                                'fuzziness': 0.5,
                                'prefix_length': 3,
                                'slop': 3
                            }
                        },
                        {
                            'bool': {
                                'should': [
                                    {
                                        'terms': {
                                            'catalog_state': [
                                                'requested',
                                                'harvested',
                                                'client_ready',
                                                'demand_generation'
                                            ]
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            'timeout': '10s',
            '_source': [
                'title',
                'parrot_id',
                'display_name',
                'catalog_state',
                'data.release_year',
                'data.type',
                'data.original_country',
                'data.original_network',
                'data.original_language',
                'data.also_known_as'
            ],
            'size': 50,
            'from': 0
        };
        return JSON.stringify(demandQuery);
    }

    createSupplyESQuery(searchTerm) {
        const supplyQuery = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'multi_match': {
                                'query': searchTerm,
                                'type': 'best_fields',
                                'fields': [
                                    'title',
                                    'display_name',
                                    'data.also_known_as^1.3'
                                ],
                                'minimum_should_match': 1,
                                'fuzziness': 0.5,
                                'prefix_length': 3,
                                'slop': 3
                            }
                        },
                        {
                            'bool': {
                                'should': [
                                    {
                                        'terms': {
                                            'catalog_state': [
                                                'metadata_ready'
                                            ]
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            'timeout': '10s',
            '_source': [
                'title',
                'parrot_id',
                'display_name',
                'catalog_state',
                'data.release_year',
                'data.type',
                'data.original_country',
                'data.original_network',
                'data.original_language',
                'data.also_known_as'
            ],
            'size': 50,
            'from': 0
        };
        return JSON.stringify(supplyQuery);
    }

    handleSearchCheckbox(checkboxName) {
        this.checkboxes[checkboxName] = !this.checkboxes[checkboxName];
    }

    onKeyUp(value) {
        this.subject.next(value);
    }

    handleInputClick($event) {
        this.inputClick.emit();
    }

    handleClick(result) {
        if (!this.disableClick && !this.bulkInfoHashSearch) {
            this.selectedDisplayName = result._source.display_name;
            this.showSearch = false;
            this.titleChange.emit([result._source.parrot_id, result._source.display_name]);
        }

        if (!this.disableClick && this.bulkInfoHashSearch) {
            this.selectedDisplayName = result.title;
            this.showSearch = false;
            this.titleChange.emit([result.contentType, result.parrotId, result.title, result.releaseYear, result.displayName]);
        }
    }

    wordCounter(searchTerm: any) {
        this.wordCount = searchTerm ? searchTerm.split(/\s+/) : 0;
        this.words = this.wordCount ? this.wordCount.length : 0;
        return this.words;
        // console.log(this.words);
    }

    elasticSearchTitle(searchTerm) {
        this.searchValue = searchTerm;
        const numOfWords = this.wordCounter(searchTerm);
        this.results = [];
        this.finalsResults = [];
        this.extendedResults = [];
        this.finalsextendedResults = [];
        this.supplyExtendedResults = [];
        this.supplyResults = [];
        this.demandExtendedResults = [];
        this.demandResults = [];
        this.loading = true;

        const typeFilters = [];
        const originalFilters = {};
        const ES_RESULTS_SIZE = 200;

        const demandQuery = this.createDemandESQuery(searchTerm);
        const supplyQuery = this.createSupplyESQuery(searchTerm);

        const query = this.catalogService.createEsQuery(searchTerm, 50, ['show', 'movie', 'sport']);


        let esIndex = 'series_metadata';
        if (this.esIndex === 'movie') {
            esIndex = 'movie_metadata';
        }

        const catalogState = ['metadata_ready', 'harvested', 'requested', 'demand_generation', 'client_ready'];

        const queryJSON = this.catalogService.createBulkInfohashDemandEsQuery(catalogState, true,
            searchTerm, ES_RESULTS_SIZE, this.catalogService.getEsDefaultSource(), 0, this.category
        );
        const directQueryJson = this.catalogService.createBulkInfohashDirectEsQuery(catalogState, true,
            searchTerm, ES_RESULTS_SIZE, this.catalogService.getEsDefaultSource(), 0, this.category
        );

        if (this.bulkInfoHashSearch) {

            if (this.category !== 'movie') {

                this.getDemandResultsForBulkInfohash(this.results, queryJSON, directQueryJson, 'series_metadata', 'show');
                this.getExtendedDemandResultsForBulkInfohashesh(this.extendedResults, queryJSON, directQueryJson, 'movie_metadata', 'movie');
            } else {
                this.getDemandResultsForBulkInfohash(this.results, queryJSON, directQueryJson, 'movie_metadata', 'movie');
                this.getExtendedDemandResultsForBulkInfohashesh(this.extendedResults, queryJSON, directQueryJson, 'series_metadata', 'show');
            }

        } else {
            this.getResultsForNonBulkInfohash(query, esIndex);
        }
    }

    private getDemandResultsForBulkInfohash(results: any[], queryJSON: string, directQueryJson: string, esIndex, contentType) {
        this.catalogService.callEsProd(
            directQueryJson,
            esIndex,
        ).then((res) => {
            this.results = this.results.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, contentType)));
            console.log('First result' + this.results);
        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
            this.loading = false;
        });

        this.catalogService.callEsProd(
            queryJSON,
            esIndex,
        ).then((res) => {
            this.results = this.results.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, contentType)));
            this.finalsResults = this.results.filter((individualObject, index, self) =>
                index === self.findIndex((t) => (
                    t.parrotId === individualObject.parrotId && t.title === individualObject.title
                ))
            );

            this.loading = false;
        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            console.log(err);
            this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
            this.loading = false;
        });
    }

    private getSupplyResultsForBulkInfohashesh(results: any[], queryJSON: string, esIndex) {
        this.catalogService.callEsProxyCustomQueryFromInfohash(
            queryJSON,
            esIndex,
        ).then((res) => {
            this.supplyResults = this.supplyResults.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, 'tv')));
            this.loading = false;
            this.showSearch = true;
            console.log(this.supplyResults);
        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            this.error = true;
            this.loading = false;
        });
    }

    private getExtendedDemandResultsForBulkInfohashesh(results: any[], queryJSON: string, directQueryJson: string, esIndex, contentType) {
        this.catalogService.callEsProd(
            directQueryJson,
            esIndex,
        ).then((res) => {
            this.extendedResults = this.extendedResults.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, contentType)));
            console.log('First result' + this.extendedResults);
        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
            this.loading = false;
        });

        this.catalogService.callEsProd(
            queryJSON,
            esIndex,
        ).then((res) => {
            this.extendedResults = this.extendedResults.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, contentType)));
            this.finalsextendedResults = this.extendedResults.filter((individualObject, index, self) =>
                index === self.findIndex((t) => (
                    t.parrotId === individualObject.parrotId && t.title === individualObject.title
                ))
            );

            this.loading = false;
        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            console.log(err);
            this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
            this.loading = false;
        });
    }

    private getExtendedSupplyResultsForBulkInfohashesh(results: any[], queryJSON: string, esIndex) {
        this.catalogService.callEsProxyCustomQueryFromInfohash(
            queryJSON,
            esIndex,
        ).then((res) => {
            this.supplyExtendedResults = this.supplyExtendedResults.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, 'tv')));
            this.loading = false;
            this.showSearch = true;
            console.log(this.supplyResults);
        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            this.error = true;
            this.loading = false;
        });
    }

    private getResultsForNonBulkInfohash(query: string, esIndex: string) {
        this.catalogService.callEsProxyCustomQuery(query, this.extended ? 'master_catalog' : esIndex)
            .then(res => {
                this.results = res.hits.hits;
                this.loading = false;
                this.showSearch = true;
            })

            .catch(error => {
                console.error('Error in calling the elastic search proxy:', error.toString());
                this.error = true;
                this.loading = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/title-search-box/title.search.box.component.ts